import { render, staticRenderFns } from "./izonPage.vue?vue&type=template&id=09a674d2&scoped=true&"
import script from "./izonPage.vue?vue&type=script&lang=js&"
export * from "./izonPage.vue?vue&type=script&lang=js&"
import style0 from "./izonPage.vue?vue&type=style&index=0&id=09a674d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a674d2",
  null
  
)

export default component.exports